module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 38
// module chunks = 7